import * as React from "react";
import { SVGProps } from "react";
function SvgDownloadFileIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19 9h-4V3H9v6H5l7 7 7-7ZM5 19v2h14v-2H5Z" fill="#16A085" />
    </svg>
  );
}
export default SvgDownloadFileIcon;
